<template>

 <div class="row justify-content-center">

    <div class="col-md-10">
        <div class="fieldset">
            <h3 class="fieldset-title">Фирмени данни</h3> 
            <div class="row">

                <div class="col-md-6 col-12">

                    <div class="form-group">
                        <label for='c_brand'>Бранд</label>
                        <input class='form-control input-lg' id='c_brand' v-model='model.brand'>
                    </div>

                </div>
                <div class="col-md-6 col-12">

                    <div class="form-group">
                        <label for='c_name'>Име на фирмата</label>
                        <input class='form-control input-lg' id='c_name' v-model='model.name'>
                    </div>

                </div>
                <div class="col-md-6 col-12">

                    <div class="form-group">
                        <label for='eik'>ЕИК</label>
                        <input class='form-control input-lg' id='eik' v-model='model.eik'>
                    </div>

                </div>
                <div class="col-md-6 col-12">

                    <div class="form-group">
                        <label for='mol'>МОЛ</label>
                        <input class='form-control input-lg' id='mol' v-model='model.mol'>
                    </div>

                </div>
                <div class="col-md-6 col-12">

                    <div class="form-group">
                        <label for='c_city'>Град</label>
                        <input class='form-control input-lg' id='c_city' v-model='model.city'>
                    </div>

                </div>
                <div class="col-md-6 col-12">

                    <div class="form-group">
                        <label for='c_addr'>Адрес</label>
                        <input class='form-control input-lg' id='c_addr' v-model='model.address'>
                    </div>

                </div>
                <div class="col-12">

                    <div class="form-group">
                        <label for='bank_info'>Банкови данни</label>
                        <input type="text" class='form-control input-lg' id='bank_info' v-model='model.bank_info'>
                    </div>

                </div>

                <div class='col-12 text-center'>
                    <form-validator ref='validator' :fields='validatorFields'></form-validator>

                    <button @click='save' class='btn btn-success btn-lg mt-2' :disabled='isLoading'>
                        <span class="icon icon-save"></span>
                        Запази
                    </button>

                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        beforeDestroy() {

        },

        created() {

        },

        props : ['uid'],

        data() {
            return {

                model : false,
                isLoading : false,

                mdl : {
                    'user_id'   : null,
                    'name'      : '',
                    'brand'     : null,
                    'mol'       : '',
                    'eik'       : '',
                    'address'   : '',
                    'city'      : '',
                    'bank_info' : '',
                },

                //Validate Company info
                validatorFields : [
                    { 
                        selector  : "#c_name",
                        minLength : 2,
                        customErr : 'Моля въведете име на фирмата'
                    },
                    { 
                        selector  : "#mol",
                        minLength : 2,
                        customErr : 'Моля въведете MOL'
                    },
                    { 
                        selector  : "#eik",
                        minLength : 2,
                        customErr : 'Моля въведете ЕИК'
                    },
                    { 
                        selector  : "#c_addr",
                        minLength : 2,
                        customErr : 'Моля въведете адрес на фирмата'
                    },
                    { 
                        selector  : "#c_city",
                        minLength : 2,
                        customErr : 'Моля въведете градa на фирмата'
                    },,
                    { 
                        selector  : "#bank_info",
                        minLength : 2,
                        customErr : 'Моля въведете информация за банковата сметка на фирмата'
                    },
                   
                ],

            }
        },

        methods : {

          getData() {
                var me = this;

                me.isLoading = true;

                me.ajax.call('usr:gci', { fields : { user_id : this.$route.params.id } }, (r) => {
                    me.isLoading = false;
                    
                    if( r.status == 'success' ) {

                        if( r.data != null ) {

                            me.model  = r.data;
                            
                        } else {

                            me.model = Object.assign( {}, me.mdl );

                        }

                        me.isReady = true;

                    }

                })
            },

            save() {

                var me = this;
                var payload = { fields : this.model };

                this.$refs.validator.validate({
                    resolve(){

                        me.isLoading = true;

                        me.ajax.call('usr:sci', me.model, (r) => {
                            me.isLoading = false;

                            if( r.status == 'success' ) {

                                me.notify('save-success');

                            }

                        })

                    }
                })

            },
        }

    }
</script>
